export default __webpack_public_path__ + "static/media/17.2f68f1b9.png";